import React from 'react'

export const Revert = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.07031 8.00242C5.808 6.72471 6.88466 5.67587 8.18125 4.97188C9.47783 4.2679 10.9438 3.93617 12.4172 4.01339C13.8906 4.0906 15.3139 4.57375 16.5298 5.40941C17.7457 6.24508 18.7068 7.4007 19.3069 8.74853'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M3.2304 5.51837L3.95981 8.6779C4.08405 9.21603 4.621 9.55156 5.15913 9.42733L8.31867 8.69792'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M18.9277 15.9976C18.19 17.2753 17.1134 18.3241 15.8168 19.0281C14.5202 19.7321 13.0542 20.0638 11.5808 19.9866C10.1075 19.9094 8.68418 19.4263 7.46828 18.5906C6.25238 17.7549 5.29126 16.5993 4.69117 15.2515'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M20.7676 18.4816L20.0382 15.3221C19.914 14.784 19.377 14.4484 18.8389 14.5727L15.6794 15.3021'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}
